/**
 * bb is the bounding box
 * ix,iy are the top-left coordinates
 * ax,ay are the bottom-right coordinates
 * p is the point and x,y its coordinates
 */

export default function detectTouchPoint(region, e) {
  const bb = region.getBoundingClientRect();
  const pX = e.touches[0].clientX;
  const pY = e.touches[0].clientY;
  const ix = bb.x;
  const iy = bb.y;
  const ax = bb.right;
  const ay = bb.bottom;

  let result = false;

  if (ix <= pX && pX <= ax && iy <= pY && pY <= ay) {
    // Point is in bounding box
    result = true;
  }

  return result;
}
